import React, { FC } from 'react';
import s from './index.scss';
import starImg from './img/star.svg';
import starHalfImg from './img/starHalf.png';
import starEmptyImg from './img/starEmpty.svg';

interface StarsRaitingProps {
	stars?: number[];
}

const StarsRaiting: FC<StarsRaitingProps> = props => {
	// 1 - fullStar, 0 - emptyStar, 2 - halfStar
	const { stars = [1, 1, 1, 1, 1] } = props;

	return (
		<div className={s.stars}>
			{stars.map((star: number, index: number) => {
				return (
					<img
						src={star === 2 ? starHalfImg : star ? starImg : starEmptyImg}
						alt='star'
						key={index}
					/>
				);
			})}
		</div>
	);
};

export default StarsRaiting;
